import {Injectable, TemplateRef} from '@angular/core';
import {asapScheduler, BehaviorSubject, distinctUntilChanged, observeOn} from 'rxjs';

// Provided by the authenticated shell, so standalone editors keep local actions.
@Injectable()
export class EditorActionsService {
  private readonly templateSubject = new BehaviorSubject<TemplateRef<unknown> | null>(null);
  readonly template$ = this.templateSubject.pipe(distinctUntilChanged(), observeOn(asapScheduler));

  private confirmRefresh?: () => Promise<boolean>;

  requestRefresh(): Promise<boolean> {
    return this.confirmRefresh?.() ?? Promise.resolve(true);
  }

  register(template: TemplateRef<unknown>, confirmRefresh?: () => Promise<boolean>): void {
    this.confirmRefresh = confirmRefresh;
    this.templateSubject.next(template);
  }

  release(template: TemplateRef<unknown>): void {
    // A departing editor must not clear actions registered by the next route.
    if (this.templateSubject.value === template) {
      this.confirmRefresh = undefined;
      this.templateSubject.next(null);
    }
  }
}
